<template>
  <v-container  style="background:white; text-align:center">
    <v-layout justify-center> 
      <h2 class="font-weight-bold" >{{language === 'English'?'Log in':'Iniciar Sesion'}}</h2>
    </v-layout>
    <v-card-actions>
      <v-flex>
        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
          <div>
            <v-text-field  :label="language === 'English'?'Username or Email':'Nombre de usuario o Email'" :rules="[rules.required]" 
              v-model="loginuser.datauser"  required id="datauser">
            </v-text-field>
            <v-layout v-if="userexist">
              <label class ="fas fa-exclamation-triangle"> {{language === 'English'?`User don't registered, please`:'Usuario no registrado, por favor'}}
                <a @click="goregisteruser">{{language === 'English'?'Sign up':'Registrese'}}</a>
              </label>
            </v-layout>
          </div>
          <div>
            <v-text-field required :append-icon="InputLoginPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" :rules="[rules.required, rules.min]" :type="InputLoginPassword ? 'text' : 'password'" name="input-10-1" color="black" 
              v-model="loginuser.password" :label="language === 'English'?'Password':'Contraseña'" :hint="language === 'English' ? 'At least 8 caracters':'Al menos 8 carácteres'" @click:append="InputLoginPassword = !InputLoginPassword" id="password">
            </v-text-field>
            <v-layout v-if="incorrectpassword">
              <label class ="fas fa-exclamation-triangle"> {{language === 'English'?'Incorrect Password':'Contraseña Incorrecta'}}</label>
            </v-layout>            
          </div>
          <br>
          <div style="display:flex; justify-content:center">
            <v-btn v-if="!isloading" :disabled="!valid" color="#C7A7BE"  large style="border-radius:5px" type="submit">{{language === 'English'?'Log in':'Iniciar Sesion'}}</v-btn>
            <v-progress-circular
              v-if="isloading"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <br/>
          <!--div style="display:flex; justify-content:center">
              <a @click="opendialogforgetpassword">¿Has olvidado tu contraseña?</a>
          </div-->
          <br/>
        </v-form>
        <!-- RESTABLECER CONTRASEÑA-->
        <v-layout>
          <v-dialog v-model="dialogforgetpassword" max-width="500">
            <form @submit.prevent="emailvalidate">
              <v-card>
                <v-layout justify-center>
                  <v-card-title style="font-size:20px">Introduce el email que usaste para registrarte</v-card-title>
                </v-layout>
                <v-layout justify-center>
                  <v-flex xs10 sm10 md10 > 
                    <v-text-field :rules="[rules.required]" required v-model="forgetpassword.email" label="Email" id="emailforgetpassword">                        
                    </v-text-field>
                    <v-layout v-if="userexistforgetpassword">
                      <label class ="fas fa-exclamation-triangle"> Usuario no Registrado, por favor Registrese</label>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-card-actions>
                  <v-layout justify-center>
                    <v-btn type="submit" color="primary" style="align:center">RESTABLECER</v-btn> 
                  </v-layout>
                </v-card-actions>
              </v-card>
            </form>
          </v-dialog>
        </v-layout> 
        <!-- CODIGO DE CONFIRMACION-->
        <v-layout justify-center>
          <v-dialog v-model="dialogvalidatecode" max-width="600"> 
            <form @submit.prevent="validatetokenandpassword">
              <v-card>
                <v-layout justify-center>
                  <v-card-title style="font-size:20px">Introduce el codigo de confirmacion</v-card-title>
                </v-layout>
                <v-layout justify-center>
                  <v-flex xs10 sm10 md10 > 
                    <v-text-field  :rules="[rules.required]" v-model="forgetpassword.codesegurity" id="token" required label="Introducir codigo">                       
                    </v-text-field>
                    <v-layout v-if="tokenvalidateerror">
                      <label class ="fas fa-exclamation-triangle">Código no valido</label>
                    </v-layout>
                  </v-flex>
                </v-layout >
                <v-layout justify-center>
                  <v-flex xs10 sm10 md10 >
                    <label style="text-align:center">¿No te llego el codigo? Prueba esto: </label>
                    <a @click="emailvalidate" style="color:black; font-weight:bold">    Reenviar codigo </a >
                  </v-flex>
                </v-layout>
                <v-layout justify-center>
                  <v-btn  type="submit" color="primary" style="text-align:center">ENVIAR CÓDIGO</v-btn>
                </v-layout> 
                <v-card-actions>
                  <v-layout justify-center>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </form>
          </v-dialog>
        </v-layout> 
        <!-- NUEVA CONTRASEÑA-->
        <v-layout justify-center>
          <v-flex xs10 sm10 md10 >
            <v-dialog v-model="dialogchangepassword" max-width="600"> 
              <form @submit.prevent="validatetokenandpassword">
                <v-card>
                  <v-layout justify-center >
                    <v-card-title style="font-size:20px">Cambiar contraseña</v-card-title>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex xs10 sm10 md10 > 
                        <v-card-title style="font-size:12px,text-align:center">Por favor introduce tu nueva contraseña <br>Recuerda que la contraseña distingue entre mayusculas y minusculas<br></v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex xs10 sm10 md10 > 
                      <v-text-field id="passreg" :append-icon="showforgetpassword  ? 'visibility_off' : 'visibility'" :type="showforgetpassword ? 
                        'text' : 'password'" @click:append="showforgetpassword = !showforgetpassword" :rules="[rules.required]" 
                        v-model="forgetpassword.password" required  label="Nueva contraseña">
                      </v-text-field>
                      <v-layout v-if="passlength">
                        <label id= "erroremptyname" class ="fas fa-exclamation-triangle">Tu contraseña debe tener 8 caracteres</label>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex xs10 sm10 md10 > 
                      <v-text-field :append-icon="showforgetpasswordconfirm  ? 'visibility_off' : 'visibility'" :type="showforgetpasswordconfirm ? 'text' : 
                        'password'" @click:append="showforgetpasswordconfirm  = !showforgetpasswordconfirm " :rules="[rules.required]"  required id="passreg2"  
                        label="Confirmar contraseña">
                      </v-text-field>
                      <v-layout v-if="passequalserror">
                        <label id= "erroremptyname" class ="fas fa-exclamation-triangle">La Contraseña no coincide con la anterior</label>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-card-actions>
                    <v-layout justify-center>
                      <v-btn type="submit" color="primary" style="align:center">ACEPTAR</v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </form>
            </v-dialog>
          </v-flex>
        </v-layout> 

        <!--div style="padding-top:15.5px; display:flex; justify-content:center">
          <div style="width:20%">
            <a style="cursor:pointer"><i style="font-size: 30px" class="fab fa-facebook-f" @click="LoginwithFacebook"></i></a> 
          </div>
          <div style="width:20%">
            <a style="cursor:pointer"><i  style="font-size: 30px" class="fab fa-google" @click="LoginwithGoogle"></i></a>
          </div>
          <div style="width:20%">
            <a style="cursor:pointer"><i style="font-size: 30px" class="fab fa-twitter" @click="LoginwithTwitter"></i></a>
          </div>
        </div-->
        <br/>
        <div style="padding:10px; display:flex; justify-content:center">
          <label>{{language === 'English' ? 'You still do not have an account?':'¿Todavia no tienes una cuenta?'}}</label>
          <a @click="goregisteruser" style="margin-left: 5px">{{language === 'English' ? 'Sign up here':'Registrate Aqui'}}</a>
        </div>
      </v-flex>
    </v-card-actions>
  </v-container>
</template>

<script>

//import renderauthsocialnetwork from '../../../../helpers/renderauthsocialnetwork'
import { EventBus } from '../../../../helpers/eventbus/event-bus'
const alertify = require('alertifyjs')

import initVue from '../../../../helpers/initVue'
// Modelos
import LoginUser from '../../../../models/loginuser'
import config from '../../../../config/env.example'
import forgetpassword from '../../../../models/forgetpassword'
import {UsersService} from "@/services"

import {
    mapGetters,
    mapActions
} from 'vuex'
  export default {
      data () {
       return {
          language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
          valid: true,
          InputLoginPassword: false,
          showforgetpassword: false,
          showforgetpasswordconfirm: false,
          modalsocialnetwork: false,
          socialnetworkurl: '',
          isloading:false,
          loginuser: new LoginUser(),
          forgetpassword : new forgetpassword(),
          userexist: false,
          incorrectpassword: false,
          identity: null,
          userexistforgetpassword: false,
          passequalserror: false,
          passvalidate: false,
          passlength: false,
          token: null,
          session: false,
          state: false,
          dialogforgetpassword: false,
          modallogin:false,
          tokenvalidateerror: false,
          dialogvalidatecode: false,
          dialogchangepassword:false,
          rules: {
            required: value => !!value || `${this.language === 'English'?'Required':'Requerido.'}`,
            min: v =>  v && v.length >= 8 || `${this.language === 'English'?'Minimum 8 characters':'Minimo 8 carácteres'}`,
            passwordvalidate: value => {
              const pattern = /^(?=.*\d)(?=.*[a-záéíóúüñ]).*[A-ZÁÉÍÓÚÜÑ]/
              return pattern.test(value) || 'Tu contraseña debe tener un carácter, una letra mayúscula, una minúscula y un número'
            },
            emailMatch: () => ('El correo electrónico y la contraseña que ingresaste no coinciden'),
            passwordspace: value =>{
              const pattern = /\s/
              return !pattern.test(value) || 'No dejes espacios en blanco'
            }
          }
        }
      },
      computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
      }),
      

      mounted(){
        this.getidentity()
        EventBus.$on('changelanguage',()=>{
            let choosedlanguage = JSON.parse(localStorage.getItem('language'))
            this.language = choosedlanguage.language
            //console.log(this.language)
            //console.log(choosedlanguage)
        })
        let choosedlanguage = JSON.parse(localStorage.getItem('language'))
        if(choosedlanguage){
            this.language = choosedlanguage.language
        }
        
      },
      methods: {

        goregisteruser(){
          this.$emit('activeRegister',1)
        },
        
        opendialogforgetpassword(){
          this.dialogforgetpassword=true
        },
        opendialogvalidatecode(){
          this.dialogvalidatecode=true
           this.dialogforgetpassword=false
        },
        opendialogchangepassword(){
          this.dialogchangepassword=true
           this.dialogvalidatecode=false
        },
        Finalizemodalforgetpassword(){
          this.dialogchangepassword=false
          
        },

        goLogin(){
          this.modallogin = true
        },

        /*******************************************************
 * * Obteniendo la identidad para validar el token
 *******************************************************/
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            //console.log(this.identity)
        },
        
        /****************** * Guardar datos para identificar si el usuarios ha iniciado sesión ***************************************************+*/
        saveIdentity() {
            this.$store.dispatch('saveIdentity', this.identity)
            localStorage.setItem('iden', JSON.stringify(this.identity))
            this.$store.dispatch('saveToken', this.token)
            localStorage.setItem('tok', this.token)
        },
        

        LoginwithFacebook(){
          //renderauthsocialnetwork.rendersocialnetwork = true
          window.location = `${config.host}auth/facebook`
        },

        LoginwithGoogle(){
          //renderauthsocialnetwork.rendersocialnetwork = true
          window.location = `${config.host}auth/google`
        },

        LoginwithTwitter(){
          //renderauthsocialnetwork.rendersocialnetwork = true
          window.location = `${config.host}auth/twitter`
        },

        validate () {
          if (this.$refs.form.validate()) {
            this.snackbar = true
            this.isloading = true
            //this.loginuser.dni = this.loginuser.dni
            this.loginuser.gettoken = true
            UsersService.login(this.loginuser).then(res=>{
                this.identity = res.data.user
                this.token = res.data.token
                setTimeout(() => {
                    this.saveIdentity()
                    let isemailorusernameequal = this.$route.params.nameuser === res.data.username
                    
                    let isindex = this.$route.name ==='Index'
                    if(isindex){                    
                      window.location = `/`
                    }else if(isemailorusernameequal){
                      window.location = `/`
                    }else{
                      window.location = window.location.href
                    }
                }, 400)
            }).catch((err) => {
                  let msg = err.response.data.message

                  if (msg === "Usuario no Registrado, porfavor Registrese") {
                      this.userexist = true
                      document.getElementById('datauser').focus()
                      setTimeout(() => {
                          this.userexist = false
                      }, 5000)
                  }

                  if (msg === "La Contraseña es incorrecta, intentelo de nuevo") {
                      this.incorrectpassword = true
                      document.getElementById('password').focus()
                      setTimeout(() => {
                          this.incorrectpassword = false
                      }, 5000)
                  }
                  this.isloading = false
                  
              })
            /*
            this.axios.post('users/loginuser',this.loginuser)
                .then((res) => {
                  //console.log(res)
                    let msg = res.data.message
                    this.identity = res.data.user
                    this.token = res.data.token
                    
                    setTimeout(() => {
                        this.saveIdentity()
                        window.location = `/`
                    }, 400)
                    //this.getidentity()
                    //this.getuserforLocalStorage()
                
                })
                .catch((err) => {
                  console.log(err)
                    let msg = err.response.data.message

                    if (msg === "Usuario no Registrado, porfavor Registrese") {
                        this.userexist = true
                        document.getElementById('datauser').focus()
                        setTimeout(() => {
                            this.userexist = false
                        }, 5000)
                    }

                    if (msg === "La Contraseña es incorrecta, intentelo de nuevo") {
                        this.incorrectpassword = true
                        document.getElementById('password').focus()
                        setTimeout(() => {
                            this.incorrectpassword = false
                        }, 5000)
                    }
                    this.isloading = false
                    
                })*/
          }

        },
//Validar email y enviar código
        emailvalidate(){
            this.axios.put('users/forgetpasswordsendemail',this.forgetpassword)
                .then((res) => {
                  this.opendialogvalidatecode()
                })
                .catch((err) => {
                  console.log(err)
                  let msg = err.response.data.message

                    if (msg === "Usuario no Registrado") {
                        this.userexistforgetpassword = true
                        document.getElementById('emailforgetpassword').focus()
                        setTimeout(() => {
                            this.userexistforgetpassword = false
                        }, 5000)
                    }
                })
        },

        validatetokenandpassword(){
          let statetrue = this.state === true
        
          if(statetrue){
            const passuser = document.getElementById('passreg').value
            const passuserconfirm = document.getElementById('passreg2').value
            const desequalpassword = passuser != passuserconfirm
            const tamañopassword = passuser.length < 8
            if(desequalpassword){
              this.passequalserror=true
              document.getElementById('passreg2').focus()
                setTimeout(() => {
                    this.passequalserror=false
                }, 5000)
            }else if(tamañopassword){
                this.passlength=true
                document.getElementById('passreg').focus()
                setTimeout(() => {
                    this.passlength=false
                }, 5000)
            }else{
              this.axios.put(`users/forgetpasswordvalidatetoken/${this.state}`,this.forgetpassword)
                    .then((res) => {
                      this.Finalizemodalforgetpassword()
                      alertify.success('Contraseña Editada, puede Iniciar Sesión')
                      this.state = false
                    })
                    .catch((err) => {
                      console.log(err)
                    })
            }
          }else{
            this.axios.put(`users/forgetpasswordvalidatetoken/${this.state}`,this.forgetpassword)
                  .then((res) => {
                    this.opendialogchangepassword()
                    //console.log(res.data.success)
                    this.state = res.data.success
                    //console.log(this.state)
                  })
                  .catch((err) => {
                    console.log(err)
                    let msg = err.response.data.message

                      if (msg === "No coinciden") {
                          this.tokenvalidateerror = true
                          document.getElementById('token').focus()
                          setTimeout(() => {
                              this.tokenvalidateerror = false
                          }, 5000)
                      }
                  })
          }
        }

      }
      
  }
</script>
